var map = {
	"./chevron-right.svg": "6fa3",
	"./facebook.svg": "c126",
	"./google.svg": "e260",
	"./instagram.svg": "48c8",
	"./linkedin.svg": "d499",
	"./settings.svg": "c4eb",
	"./telegram.svg": "a238",
	"./tiktok.svg": "f265",
	"./twitter.svg": "2378",
	"./whatsapp.svg": "31c2",
	"./youtube.svg": "f95b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "88de";